"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PaginationDots", {
  enumerable: true,
  get: function () {
    return _PaginationDots.default;
  }
});
var _PaginationDots = _interopRequireDefault(require("./PaginationDots"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }